import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const AgentStatusGrid = () => {
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null);

  // Mock agent data
  useEffect(() => {
    const mockAgents = [
    {
      id: 1,
      name: "Ahmet Yılmaz",
      extension: "101",
      status: "on-call",
      avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_13774aa56-1762273430434.png",
      avatarAlt: "Professional Turkish man in dark suit with confident smile",
      currentCall: {
        customer: "Mehmet Demir",
        duration: 245,
        type: "inbound"
      },
      todayStats: {
        callsHandled: 23,
        avgCallTime: "4:32",
        satisfaction: 4.2
      }
    },
    {
      id: 2,
      name: "Zeynep Kaya",
      extension: "102",
      status: "available",
      avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_17e878dda-1762273600612.png",
      avatarAlt: "Professional Turkish woman with dark hair in business attire smiling",
      currentCall: null,
      todayStats: {
        callsHandled: 31,
        avgCallTime: "3:45",
        satisfaction: 4.7
      }
    },
    {
      id: 3,
      name: "Emre Özkan",
      extension: "103",
      status: "busy",
      avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_154ce1cb5-1762273514228.png",
      avatarAlt: "Young Turkish man with beard wearing casual shirt",
      currentCall: null,
      todayStats: {
        callsHandled: 18,
        avgCallTime: "5:12",
        satisfaction: 3.9
      }
    },
    {
      id: 4,
      name: "Ayşe Demir",
      extension: "104",
      status: "on-call",
      avatar: "https://images.unsplash.com/photo-1730701804999-0e37666182e8",
      avatarAlt: "Professional Turkish woman with hijab in office environment",
      currentCall: {
        customer: "Fatma Şahin",
        duration: 128,
        type: "outbound"
      },
      todayStats: {
        callsHandled: 27,
        avgCallTime: "4:01",
        satisfaction: 4.5
      }
    },
    {
      id: 5,
      name: "Burak Çelik",
      extension: "105",
      status: "away",
      avatar: "https://images.unsplash.com/photo-1656337049976-a9312808ecb1",
      avatarAlt: "Turkish man in casual blue shirt with friendly expression",
      currentCall: null,
      todayStats: {
        callsHandled: 15,
        avgCallTime: "6:23",
        satisfaction: 4.1
      }
    },
    {
      id: 6,
      name: "Selin Arslan",
      extension: "106",
      status: "on-call",
      avatar: "https://images.unsplash.com/photo-1690622006386-5970822da733",
      avatarAlt: "Young Turkish woman with long dark hair in professional setting",
      currentCall: {
        customer: "Ali Vural",
        duration: 67,
        type: "inbound"
      },
      todayStats: {
        callsHandled: 29,
        avgCallTime: "3:28",
        satisfaction: 4.8
      }
    }];

    setAgents(mockAgents);
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case 'available':return 'bg-green-100 text-green-800 border-green-200';
      case 'on-call':return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'busy':return 'bg-red-100 text-red-800 border-red-200';
      case 'away':return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      default:return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'available':return 'CheckCircle';
      case 'on-call':return 'Phone';
      case 'busy':return 'XCircle';
      case 'away':return 'Clock';
      default:return 'Circle';
    }
  };

  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs?.toString()?.padStart(2, '0')}`;
  };

  const handleAgentAction = (agentId, action) => {
    console.log(`Supervisor action: ${action} for agent ${agentId}`);
    // Simulate supervisor actions
  };

  return (
    <div className="bg-white rounded-lg border border-slate-200 shadow-sm">
      <div className="p-6 border-b border-slate-200">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-semibold text-slate-900">Temsilci Durumu</h3>
            <p className="text-sm text-slate-600 mt-1">Gerçek zamanlı temsilci aktivitesi ve performans</p>
          </div>
          <div className="flex items-center space-x-2">
            <div className="flex items-center space-x-4 text-sm">
              <div className="flex items-center space-x-1">
                <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                <span className="text-slate-600">Müsait: {agents?.filter((a) => a?.status === 'available')?.length}</span>
              </div>
              <div className="flex items-center space-x-1">
                <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                <span className="text-slate-600">Aramada: {agents?.filter((a) => a?.status === 'on-call')?.length}</span>
              </div>
              <div className="flex items-center space-x-1">
                <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                <span className="text-slate-600">Meşgul: {agents?.filter((a) => a?.status === 'busy')?.length}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {agents?.map((agent) =>
          <div
            key={agent?.id}
            className="border border-slate-200 rounded-lg p-4 hover:shadow-md transition-shadow duration-200 cursor-pointer"
            onClick={() => setSelectedAgent(agent)}>

              {/* Agent Header */}
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center space-x-3">
                  <div className="relative">
                    <img
                    src={agent?.avatar}
                    alt={agent?.avatarAlt}
                    className="w-10 h-10 rounded-full object-cover" />

                    <div className={`absolute -bottom-1 -right-1 w-4 h-4 rounded-full border-2 border-white ${
                  agent?.status === 'available' ? 'bg-green-500' :
                  agent?.status === 'on-call' ? 'bg-blue-500' :
                  agent?.status === 'busy' ? 'bg-red-500' : 'bg-yellow-500'}`
                  }></div>
                  </div>
                  <div>
                    <h4 className="font-medium text-slate-900">{agent?.name}</h4>
                    <p className="text-xs text-slate-500">Dahili: {agent?.extension}</p>
                  </div>
                </div>
                <div className="flex items-center space-x-1">
                  <button
                  onClick={(e) => {
                    e?.stopPropagation();
                    handleAgentAction(agent?.id, 'monitor');
                  }}
                  className="p-1 text-slate-400 hover:text-slate-600 rounded"
                  title="İzle">

                    <Icon name="Eye" size={16} />
                  </button>
                  <button
                  onClick={(e) => {
                    e?.stopPropagation();
                    handleAgentAction(agent?.id, 'whisper');
                  }}
                  className="p-1 text-slate-400 hover:text-slate-600 rounded"
                  title="Fısılda">

                    <Icon name="MessageCircle" size={16} />
                  </button>
                </div>
              </div>

              {/* Status Badge */}
              <div className="mb-3">
                <span className={`inline-flex items-center px-2 py-1 text-xs font-medium rounded-full border ${getStatusColor(agent?.status)}`}>
                  <Icon name={getStatusIcon(agent?.status)} size={12} className="mr-1" />
                  {agent?.status === 'available' ? 'Müsait' :
                agent?.status === 'on-call' ? 'Aramada' :
                agent?.status === 'busy' ? 'Meşgul' : 'Uzakta'}
                </span>
              </div>

              {/* Current Call Info */}
              {agent?.currentCall &&
            <div className="mb-3 p-2 bg-blue-50 rounded-lg">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm font-medium text-blue-900">{agent?.currentCall?.customer}</p>
                      <p className="text-xs text-blue-600">
                        {agent?.currentCall?.type === 'inbound' ? 'Gelen Arama' : 'Giden Arama'}
                      </p>
                    </div>
                    <div className="text-right">
                      <p className="text-sm font-mono font-medium text-blue-900">
                        {formatDuration(agent?.currentCall?.duration)}
                      </p>
                      <div className="flex items-center space-x-1 mt-1">
                        <button
                      onClick={(e) => {
                        e?.stopPropagation();
                        handleAgentAction(agent?.id, 'barge');
                      }}
                      className="p-1 text-blue-600 hover:text-blue-800 rounded"
                      title="Aramaya Katıl">

                          <Icon name="PhoneCall" size={12} />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
            }

              {/* Today's Stats */}
              <div className="grid grid-cols-3 gap-2 text-center">
                <div>
                  <p className="text-lg font-semibold text-slate-900">{agent?.todayStats?.callsHandled}</p>
                  <p className="text-xs text-slate-500">Arama</p>
                </div>
                <div>
                  <p className="text-lg font-semibold text-slate-900">{agent?.todayStats?.avgCallTime}</p>
                  <p className="text-xs text-slate-500">Ort. Süre</p>
                </div>
                <div>
                  <p className="text-lg font-semibold text-slate-900">{agent?.todayStats?.satisfaction}</p>
                  <p className="text-xs text-slate-500">Memnuniyet</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Agent Detail Modal */}
      {selectedAgent &&
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
            <div className="p-6 border-b border-slate-200">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold text-slate-900">Temsilci Detayları</h3>
                <button
                onClick={() => setSelectedAgent(null)}
                className="text-slate-400 hover:text-slate-600">

                  <Icon name="X" size={20} />
                </button>
              </div>
            </div>
            <div className="p-6">
              <div className="flex items-center space-x-4 mb-4">
                <img
                src={selectedAgent?.avatar}
                alt={selectedAgent?.avatarAlt}
                className="w-16 h-16 rounded-full object-cover" />

                <div>
                  <h4 className="text-lg font-medium text-slate-900">{selectedAgent?.name}</h4>
                  <p className="text-slate-600">Dahili: {selectedAgent?.extension}</p>
                </div>
              </div>
              
              <div className="space-y-4">
                <div className="flex items-center justify-between py-2 border-b border-slate-100">
                  <span className="text-slate-600">Durum:</span>
                  <span className={`px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(selectedAgent?.status)}`}>
                    {selectedAgent?.status === 'available' ? 'Müsait' :
                  selectedAgent?.status === 'on-call' ? 'Aramada' :
                  selectedAgent?.status === 'busy' ? 'Meşgul' : 'Uzakta'}
                  </span>
                </div>
                
                <div className="flex items-center justify-between py-2 border-b border-slate-100">
                  <span className="text-slate-600">Bugünkü Aramalar:</span>
                  <span className="font-medium">{selectedAgent?.todayStats?.callsHandled}</span>
                </div>
                
                <div className="flex items-center justify-between py-2 border-b border-slate-100">
                  <span className="text-slate-600">Ortalama Süre:</span>
                  <span className="font-medium">{selectedAgent?.todayStats?.avgCallTime}</span>
                </div>
                
                <div className="flex items-center justify-between py-2">
                  <span className="text-slate-600">Memnuniyet:</span>
                  <span className="font-medium">{selectedAgent?.todayStats?.satisfaction}/5.0</span>
                </div>
              </div>
              
              <div className="flex space-x-2 mt-6">
                <button
                onClick={() => handleAgentAction(selectedAgent?.id, 'monitor')}
                className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors">

                  İzle
                </button>
                <button
                onClick={() => handleAgentAction(selectedAgent?.id, 'whisper')}
                className="flex-1 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors">

                  Fısılda
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>);

};

export default AgentStatusGrid;